// Mixin para manejar selección múltiple de plantas
import axios from "axios";

export default {
  data() {
    return {
      plantasSeleccionadas: [],
      modoMultiPlanta: false,
      todasLasEmpresas: [] // Todas las empresas del sistema (para Salvador Seguridad)
    }
  },
  
  computed: {
    // Determinar si el usuario puede ver múltiples plantas
    // Solo aparece si el usuario tiene MÁS DE UNA empresa asignada
    puedeVerMultiPlantas() {
      const user = this.user || this.$store?.getters?.["profile/me"] || null;
      
      // Solo mostrar el botón si el usuario tiene más de una empresa asignada
      // Si solo tiene una, no tiene sentido mostrar el modo multi-planta
      return user && user.empresas && Array.isArray(user.empresas) && user.empresas.length > 1;
    },
    
    // Obtener IDs de plantas para filtrar
    plantasParaFiltrar() {
      if (!this.modoMultiPlanta) {
        return []; // Si no está en modo multi-planta, retornar vacío
      }
      
      if (this.plantasSeleccionadas.includes('all')) {
        const user = this.user || this.$store?.getters?.["profile/me"] || null;
        
        // Verificar si el usuario es de Salvador Seguridad
        const esSalvadorSeguridad = user && user.empresas && user.empresas.some(
          empresa => empresa.id_cliente_erp === "00001001"
        );
        
        // Si es de Salvador Seguridad, retornar todas las empresas del sistema
        if (esSalvadorSeguridad && this.todasLasEmpresas.length > 0) {
          return this.todasLasEmpresas.map(e => e.id);
        }
        
        // Si no, retornar todas las IDs de las plantas asignadas al usuario
        if (user && user.empresas) {
          return user.empresas.map(e => e.id);
        }
        return []; // Si no hay usuario, retornar vacío
      }
      return this.plantasSeleccionadas.filter(id => id !== 'all' && id !== null && id !== undefined);
    },
    
    // Empresas disponibles para el selector
    // Si el usuario es de Salvador Seguridad, mostrar todas las empresas del sistema
    // Si no, mostrar solo las asignadas al usuario
    availableEmpresas() {
      const user = this.user || this.$store?.getters?.["profile/me"] || null;
      
      // Verificar si el usuario pertenece a Salvador Seguridad
      const esSalvadorSeguridad = user && user.empresas && user.empresas.some(
        empresa => empresa.id_cliente_erp === "00001001"
      );
      
      // Si es de Salvador Seguridad y tenemos todas las empresas cargadas, retornarlas
      if (esSalvadorSeguridad && this.todasLasEmpresas.length > 0) {
        return this.todasLasEmpresas;
      }
      
      // Si no, retornar solo las empresas asignadas al usuario (normalizadas)
      if (!user || !user.empresas) {
        return [];
      }
      
      // Normalizar las empresas para manejar diferentes estructuras de datos
      return user.empresas.map(empresa => {
        // Si la empresa viene con estructura data.attributes (JSON:API)
        if (empresa.data && empresa.data.attributes) {
          return {
            id: empresa.id || empresa.data.id,
            alias: empresa.data.attributes.alias,
            nombre: empresa.data.attributes.nombre,
            ...empresa.data.attributes
          };
        }
        // Si viene directamente con los atributos
        return {
          id: empresa.id,
          alias: empresa.alias,
          nombre: empresa.nombre,
          ...empresa
        };
      });
    }
  },
  
  methods: {
    // Configurar filtros para múltiples plantas - EXTENSIÓN GRADUAL
    // Este método solo modifica los filtros si modoMultiPlanta está activo
    configurarFiltrosMultiPlanta(filters) {
      // Si no está en modo multi-planta, no modificar nada
      if (!this.modoMultiPlanta || this.plantasParaFiltrar.length === 0) {
        return filters;
      }
      
      // Si hay plantas específicas seleccionadas, añadir filtro
      if (this.plantasParaFiltrar.length > 0) {
        // Buscar si ya existe un filtro de empresa y reemplazarlo
        const empresaFilterIndex = filters.$and.findIndex(
          filter => filter.empresa && filter.empresa.id
        );
        
        const nuevoFiltro = {
          empresa: {
            id: { $in: this.plantasParaFiltrar }
          }
        };
        
        if (empresaFilterIndex >= 0) {
          filters.$and[empresaFilterIndex] = nuevoFiltro;
        } else {
          filters.$and.push(nuevoFiltro);
        }
      }
      
      return filters;
    },
    
    // Cargar selección de plantas desde localStorage
    cargarSeleccionPlantas() {
      const saved = localStorage.getItem('multiPlantSelection');
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.plantasSeleccionadas = parsed;
            this.modoMultiPlanta = parsed.length > 1 || parsed.includes('all');
            
            // Si estamos en modo multi-planta pero no hay selección válida, preseleccionar la planta actual
            if (this.modoMultiPlanta && !parsed.includes('all')) {
              const plantaActual = localStorage.getItem("plantaSelected");
              const empresasNormalizadas = this.availableEmpresas;
              
              if (plantaActual && plantaActual !== 'all' && empresasNormalizadas.length > 0) {
                const plantaId = parseInt(plantaActual);
                const plantaExiste = empresasNormalizadas.some(e => e.id === plantaId);
                
                // Si la planta actual no está en la selección, añadirla
                if (plantaExiste && !this.plantasSeleccionadas.includes(plantaId)) {
                  this.plantasSeleccionadas.unshift(plantaId); // Añadir al inicio
                  console.log('✅ Añadida planta actual a la selección:', plantaId);
                }
              }
            }
          }
        } catch (e) {
          console.error('Error loading plant selection:', e);
          this.plantasSeleccionadas = [];
          this.modoMultiPlanta = false;
        }
      }
    },
    
    // Guardar selección de plantas
    guardarSeleccionPlantas() {
      if (this.plantasSeleccionadas.length > 0) {
        localStorage.setItem('multiPlantSelection', JSON.stringify(this.plantasSeleccionadas));
      } else {
        localStorage.removeItem('multiPlantSelection');
      }
    },
    
    // Manejar cambio de selección de plantas
    manejarCambioPlantas(nuevaSeleccion) {
      console.log('🔍 manejarCambioPlantas - Nueva selección:', nuevaSeleccion);
      
      // Si se selecciona "all", limpiar otras selecciones
      if (nuevaSeleccion && nuevaSeleccion.includes('all')) {
        this.plantasSeleccionadas = ['all'];
      } else {
        // Si se selecciona una planta específica, quitar "all" si existe
        this.plantasSeleccionadas = Array.isArray(nuevaSeleccion) 
          ? nuevaSeleccion.filter(v => v !== 'all')
          : [];
      }
      
      // Mantener el modo multi-planta activo si hay selección
      this.modoMultiPlanta = this.plantasSeleccionadas.length > 0;
      
      this.guardarSeleccionPlantas();
      
      console.log('  - plantasSeleccionadas actualizadas:', this.plantasSeleccionadas);
      
      // Recargar datos si estamos en modo multi-planta y existe el método getList
      if (this.modoMultiPlanta && typeof this.getList === 'function') {
        this.getList();
      }
    },
    
    // Obtener información de plantas seleccionadas para mostrar
    obtenerInfoPlantasSeleccionadas() {
      if (!this.modoMultiPlanta || this.plantasSeleccionadas.length === 0) {
        return '';
      }
      
      const user = this.user || this.$store?.getters?.["profile/me"] || null;
      const esSalvadorSeguridad = user && user.empresas && user.empresas.some(
        empresa => empresa.id_cliente_erp === "00001001"
      );
      
      if (this.plantasSeleccionadas.includes('all')) {
        if (esSalvadorSeguridad && this.todasLasEmpresas.length > 0) {
          return `Todas las empresas del sistema (${this.todasLasEmpresas.length} empresas)`;
        }
        const totalPlantas = user && user.empresas ? user.empresas.length : 0;
        return `Todas las plantas asignadas (${totalPlantas} plantas)`;
      }
      
      if (this.plantasSeleccionadas.length === 1) {
        const planta = this.availableEmpresas.find(e => e.id === this.plantasSeleccionadas[0]);
        return planta ? planta.alias : `Planta ${this.plantasSeleccionadas[0]}`;
      }
      
      return `${this.plantasSeleccionadas.length} plantas seleccionadas`;
    },
    
    // Obtener todas las empresas del sistema (para usuarios de Salvador Seguridad)
    async fetchAllEmpresas() {
      try {
        const url = process.env.VUE_APP_API_BASE_URL || 'https://misepis-api.delfromsoftware.com/api';
        const response = await axios.get(
          `${url}/empresas?sort=alias:asc&pagination[pageSize]=1000`
        );

        // Mapeamos para combinar attributes + id en cada elemento
        const empresas = response.data.data.map((item) => {
          return {
            id: item.id,
            ...item.attributes,
          };
        });

        this.todasLasEmpresas = empresas;
        console.log('✅ Todas las empresas cargadas para Salvador Seguridad:', empresas.length);
        return empresas;
      } catch (error) {
        console.error('Error fetching todas las empresas:', error);
        this.todasLasEmpresas = [];
        return [];
      }
    },
    
    // Toggle para activar/desactivar modo multi-planta
    async toggleMultiPlantMode() {
      this.modoMultiPlanta = !this.modoMultiPlanta;
      
      if (this.modoMultiPlanta) {
        const user = this.user || this.$store?.getters?.["profile/me"] || null;
        
        // Verificar si el usuario es de Salvador Seguridad
        const esSalvadorSeguridad = user && user.empresas && user.empresas.some(
          empresa => empresa.id_cliente_erp === "00001001"
        );
        
        // Si es de Salvador Seguridad, cargar todas las empresas del sistema
        if (esSalvadorSeguridad && this.todasLasEmpresas.length === 0) {
          console.log('🔄 Cargando todas las empresas para Salvador Seguridad...');
          await this.fetchAllEmpresas();
        }
        
        // Normalizar las empresas disponibles para obtener los IDs correctos
        const empresasNormalizadas = this.availableEmpresas;
        
        // Preseleccionar la planta actual
        const plantaActual = localStorage.getItem("plantaSelected");
        
        if (plantaActual && plantaActual !== 'all' && empresasNormalizadas.length > 0) {
          const plantaId = parseInt(plantaActual);
          const plantaExiste = empresasNormalizadas.some(e => e.id === plantaId);
          if (plantaExiste) {
            this.plantasSeleccionadas = [plantaId];
            console.log('✅ Preseleccionada planta actual:', plantaId);
          } else {
            this.plantasSeleccionadas = empresasNormalizadas.length > 0 ? [empresasNormalizadas[0].id] : [];
            console.log('⚠️ Planta actual no encontrada, preseleccionando primera:', empresasNormalizadas[0]?.id);
          }
        } else if (empresasNormalizadas.length > 0) {
          this.plantasSeleccionadas = [empresasNormalizadas[0].id];
          console.log('✅ Preseleccionada primera planta:', empresasNormalizadas[0].id);
        } else {
          this.plantasSeleccionadas = [];
        }
      } else {
        // Al desactivar, limpiar la selección
        this.plantasSeleccionadas = [];
        this.guardarSeleccionPlantas();
        
        // Refrescar la página para mostrar la empresa por defecto
        // Esto asegura que se muestren los datos de la planta seleccionada en localStorage
        if (this.$router) {
          this.$router.go(0);
        } else {
          window.location.reload();
        }
        return; // No continuar con getList() ya que se va a refrescar
      }
      
      this.guardarSeleccionPlantas();
      
      // Recargar datos si existe el método getList (solo si estamos activando, no desactivando)
      if (typeof this.getList === 'function') {
        this.getList();
      }
    }
  },
  
  mounted() {
    // Solo cargar si el componente tiene el método getList (páginas de listado)
    if (typeof this.getList === 'function') {
      this.cargarSeleccionPlantas();
      
      // Si después de cargar no hay selección y estamos en modo multi-planta, preseleccionar la planta actual
      if (this.modoMultiPlanta && this.plantasSeleccionadas.length === 0) {
        const plantaActual = localStorage.getItem("plantaSelected");
        const empresasNormalizadas = this.availableEmpresas;
        
        if (plantaActual && plantaActual !== 'all' && empresasNormalizadas.length > 0) {
          const plantaId = parseInt(plantaActual);
          const plantaExiste = empresasNormalizadas.some(e => e.id === plantaId);
          if (plantaExiste) {
            this.plantasSeleccionadas = [plantaId];
            this.guardarSeleccionPlantas();
            console.log('✅ Preseleccionada planta actual en mounted:', plantaId);
          }
        }
      }
    }
  }
}
